/**
 * @file  listlinks/index.tsx
 * @description  ul li core element with links
 *
 * @author ogarcia (ozkary)
 *
 */
import React from 'react';
import * as S from './styles';

/**
 * @description list styled element
 *
 * @param ButtonProps
 */
const ListLinks = ({ items, className }: S.Props): JSX.Element => (
  <S.List
    dataSource={items}
    className={className}
    renderItem={(item) => (
      <S.List.Item>
        <S.Icon
          id={item.id}
          href={item.route}
          label={item.label}
          target="_blank"
        >
          <S.Image src={item.icon} preview={false} />
        </S.Icon>
      </S.List.Item>
    )}
  />
);

export default ListLinks;
